import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { finalize } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/auth/_services';
import { TipoAutenticacao } from 'src/app/auth/enums/tipo-autenticacao.enum';
import { EditalDTO } from 'src/app/model/dto/edital.dto';
import { EditalService } from 'src/app/service/edital/edital.service';
import { CadastroDialogComponent } from '../../util/cadastro-dialog/cadastro-dialog.component';
import { EsqueceuSenhaDialogComponent } from '../../util/esqueceu-senha-dialog/esqueceu-senha-dialog.component';

@Component({
  selector: 'app-login-externo',
  templateUrl: './login-externo.component.html',
  styleUrls: ['./login-externo.component.css']
})
export class LoginExternoComponent implements OnInit {

  loginText = new FormControl('', []);
  senha = new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(8)]);
  @BlockUI() blockUI: NgBlockUI;

  loading = false;
  submitted = false;
  returnUrl: string;
  error = '';
  editais: EditalDTO[] = [];

  constructor(public router: Router,
    private toasterService: ToasterService,
    public http: HttpClient,
    private authenticationService: AuthenticationService,
    private editalService: EditalService,
    public dialog: MatDialog,

  ) { }

  ngOnInit() {
    this.authenticationService.clearAuthentication();
    this.editalService.buscarEditaisAtivos(0).subscribe(({ data }) => {
      this.editais = data;
    });
  }

  login() {
    const login = this.loginText.value;
    const senha = this.senha.value;
    if (login == null || login === '' || senha == null || senha === '') {
      this.toasterService.pop('warning', 'CPF e senha são obrigatórios');
      return;
    }

    this.blockUI.start();
    this.authenticationService.authenticate(TipoAutenticacao.EXTERNO, login, senha)
      .pipe(finalize(() => this.blockUI.stop()))
      .subscribe({
        next: (response) => {
          if (response.ok) this.router.navigate(['listar-solicitacoes-advogado']);
        },
        error: () => this.toasterService.pop('error', 'Login ou Senha Inválidos')
      });
  }

  cadastro(event: Event) {
    event.preventDefault();
    this.dialog.open(CadastroDialogComponent, {
      width: '680px',
      maxHeight: '540px'
    });
  }

  esqueceuSenha(event: Event) {
    event.preventDefault();
    this.dialog.open(EsqueceuSenhaDialogComponent, {
      width: '430px',
      height: '320px'
    });
  }

}
